module.exports = __webpack_public_path__ + "img/asteroids.ad359b53.png";